import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { AgentConfigDashboard } from './Agents';
import { AndromedaJobsExplorer } from './JobsExplorer';
import { AndromedaJobViewer } from './JobViewer';

export const AndromedaUtilities = () => {
  return (
    <Switch>
      <Route
        path="/dashboard/andromeda/agents"
        component={AgentConfigDashboard}
      />
      <Route
        path="/dashboard/andromeda/jobs-explorer"
        component={AndromedaJobsExplorer}
      />
      <Route path="/dashboard/andromeda/job" component={AndromedaJobViewer} />
    </Switch>
  );
};
